var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-6"},[_c('div',{staticClass:"mb-4"},[_c('UpdateStaff',{attrs:{"details":_vm.staffDetails},on:{"clicked":_vm.onClickChild}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }